import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Warning } from "MODULES/PurchaseOrders/components/Detail/Warnings";
import { ID } from "APP_ROOT/constants";
import api from "APP_ROOT/api";
import { EXPORT_HOLD } from "MODULES/Receiving/constants";
import { properCase } from "LIB/formatters/text";

export default function StatusTags({
  purchaseOrder,
  requiresApproval,
  traceHold,
  received,
  rejected,
  traceHoldApproved
}) {
  const [coresReceived, setCoresReceived] = useState([]);

  useEffect(
    () => {
      api.purchaseOrders.receivedCores
        .search(purchaseOrder.get(ID), {})
        .then(({ data }) => {
          setCoresReceived(data.results);
        });
    },
    [purchaseOrder.get(ID)]
  );

  return (
    <div className="alert-group pull-right" style={{ marginLeft: 15 }}>
      {traceHold &&
        !traceHoldApproved &&
        !rejected &&
        !received && <Warning icon="pause" label="Trace Approval Required" />}

      {!rejected &&
        requiresApproval && [
          <Warning icon="pause" label="PO Requires Approval" />,
          purchaseOrder.get(EXPORT_HOLD) && (
            <Warning icon="pause" label={properCase(EXPORT_HOLD)} />
          )
        ]}
      {received && (
        <span className="label label-success" style={{ marginLeft: "10px" }}>
          <i className="fa fa-check-circle" />
          &nbsp;&nbsp;Received
        </span>
      )}
      {coresReceived.length > 0 && (
        <span className="label label-success" style={{ marginLeft: "10px" }}>
          <i className="fa fa-check-circle" />
          &nbsp;&nbsp; Core Received
        </span>
      )}
    </div>
  );
}

StatusTags.propTypes = {
  purchaseOrder: PropTypes.shape({}),
  received: PropTypes.bool.isRequired,
  rejected: PropTypes.bool.isRequired,
  requiresApproval: PropTypes.bool.isRequired,
  traceHold: PropTypes.bool.isRequired,
  traceHoldApproved: PropTypes.bool.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/PurchaseOrders/components/Detail/StatusTags.jsx